<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="indumentaria.nombre" />
            </div>
            <div class="col-12 mb-3">
                <Tallas :data="indumentaria"/>
                <StockTallasComponent :indumentaria="indumentaria"/>
            </div>
            <div class="col-12">
                <FormInput v-if="!indumentaria.incluida" label="Precio" type="decimal" name="precio" id="precio" rules="required" v-model="indumentaria.precio" />
                <div class="mb-3" v-else>
                    <label for="precio">Precio</label>
                    <input placeholder="0" id="precio" type="decimal" class="form-control" disabled />
                    <small>Precio del producto incluido: {{ indumentaria.precio | formatear_precio }}</small>
                </div>
            </div>
            <div class="col-12">
                <label>
                    Imagen de la indumentaria <b>(MEDIDAS: 450X450 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB)</b>
                </label>
                <div class="text-center" v-if="indumentaria.imagen">
                    <template>
                        <br/>
                        <img :src="indumentaria.imagen_formatted" style="max-height: 200px"/>
                        <br/>
                        <Button class="mt-3" @click="imagenBorrada()">Borrar</Button>
                    </template>
                </div>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="450"
                        :width="450"
                        @success="imagenSubida"
                    />
                </template>
            </div>
            <div class="col-12 mt-3">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="incluida" v-model="indumentaria.incluida"/>
                    <label class="custom-control-label pt-1" for="incluida">Incluir esta indumentaria en el precio de la categoría a la que se asocie</label>
                </div>
                <label><small>*En caso de marcar esta casilla, esta indumentaria irá incluida en el precio de la categoría. por lo que esta, pasará a costar 0€</small></label>
            </div>
            <div class="col-12 mt-3">
                <FormInput v-if="indumentaria.incluida" label="Cantidad incluida" type="number" name="cantidad-incluida" id="cantidad-incluida" rules="required" v-model="indumentaria.cantidad_incluida" />
            </div>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">GUARDAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';
    import Tallas from '@/components/common/Tallas';
    import StockTallasComponent from './components/StockTallasComponent.vue';

    export default {
        props: ['indumentaria'],
        data() {
            return {
                loading: false,
                imagen: null,
                index: 0,
                url: this.config.API_BASE + '/upload/image-indumentaria?api_key=' + localStorage.getItem('token') + '&permisos=public'
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardar();
                }
            },
            imagenBorrada() {
                this.indumentaria.imagen = '';          
            },
            imagenSubida(file, response) {
                this.imagen = response;
            },
            guardar() {
                if (this.imagen) {
                    this.indumentaria.imagen = this.imagen;
                }
                this.$emit('terminado');
            },
        },
        components: {
            Dropzone, Tallas, StockTallasComponent
        }
    }
</script>